import dayjs, { Dayjs } from "dayjs";

export interface FilterValues {
  name: string;
  record: string;
  dateRange: [Dayjs, Dayjs] | null;
  private: boolean | undefined;
}

export function filtersToHash(filters: FilterValues): string {
  const params = new URLSearchParams();
  
  if (filters.name) {
    params.set("name", filters.name);
  }
  
  if (filters.record) {
    params.set("record", filters.record);
  }
  
  if (filters.dateRange && filters.dateRange[0] && filters.dateRange[1]) {
    params.set("dateStart", filters.dateRange[0].toISOString());
    params.set("dateEnd", filters.dateRange[1].toISOString());
  }
  
  if (filters.private !== undefined) {
    params.set("private", String(filters.private));
  }
  
  const hash = params.toString();
  return hash ? `#${hash}` : "";
}

export function hashToFilters(): FilterValues {
  const hash = window.location.hash.slice(1);
  if (!hash) {
    return {
      name: "",
      record: "",
      dateRange: null,
      private: undefined,
    };
  }
  
  const params = new URLSearchParams(hash);
  const filters: FilterValues = {
    name: params.get("name") || "",
    record: params.get("record") || "",
    dateRange: null,
    private: undefined,
  };
  
  const dateStart = params.get("dateStart");
  const dateEnd = params.get("dateEnd");
  if (dateStart && dateEnd) {
    const start = dayjs(dateStart);
    const end = dayjs(dateEnd);
    if (start.isValid() && end.isValid()) {
      filters.dateRange = [start, end];
    }
  }
  
  const privateParam = params.get("private");
  if (privateParam === "true") {
    filters.private = true;
  } else if (privateParam === "false") {
    filters.private = false;
  }
  
  return filters;
}

export function updateHash(filters: FilterValues): void {
  const hash = filtersToHash(filters);
  if (hash !== window.location.hash) {
    window.history.replaceState(null, "", hash || window.location.pathname);
  }
}
